export default "__VITE_ASSET__db2f30a2__"